export const iconFontAwesomeShapesCertificate = (
	<i className="fa-solid fa-certificate"></i>
);
